import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";

type State = {
  nome: string;
  status: number;
};

type Actions = {
  setNome: SetFunction<string>;
  setStatus: SetFunction<number>;
  clearFilters: () => void;
};
export const initialFiltersValues: State = {
  nome: "",
  status: 1,
}

export const useChecklistListaFilters = create<State & Actions>((set) => ({
  ...initialFiltersValues,
  setNome: (vfn) => SetFunctionImpl(set, 'nome', vfn),
  setStatus: (vfn) => SetFunctionImpl(set, 'status', vfn),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
  })),
}));